import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 登录
interface LoginData {
    userName: string,
    password: string,
}
export const login = (data: LoginData): any => http.httpPost({
    url: httpApi.user.login,
    data,
})

// 登出
interface LogoutJson {
    token: string,
}
export const logout = (json: LogoutJson) => http.httpPost({
    url: httpApi.user.logout,
    json
})

// 用户主页--我回复的
interface ReplyUserJson {
    token: string,
    page: number,
    size: number
}
export const replyUser = (json: ReplyUserJson): any => http.httpGet({
    url: httpApi.user.replyUser,
    json
})

// 获取用户信息
interface InfoJson {
    token: string
}
export const getUserInfo = (json: InfoJson): any => http.httpGet({
    url: httpApi.user.getInfo,
    json
})


// 获取用户信息
export const getMenu = (): any => $fn.httpPost({
    url: httpApi.user.getMenu,
})

interface DetailListJson {
    token: string,
    type: string
}
export const DetailList = (json: DetailListJson): any => http.httpGet({
    url: httpApi.user.DetailList,
    json
})

// 获取手机号验证码
interface GetPhoneCodeData {
    phone: string
}
export const getPhoneCode = (json: GetPhoneCodeData): any => http.httpPost({
    url: httpApi.user.getPhoneCode,
    json
})

export const getProvince = (json: InfoJson): any => http.httpGet({
    url: httpApi.user.getProvince,
    json
})

// 校验手机验证码
interface CheckPhoneCode {
    phone: string,
    code: string
}
export const checkPhoneCode = (json: CheckPhoneCode): any => http.httpPost({
    url: httpApi.user.checkPhoneCode,
    json
})

// 用户首次登陆修改密码
interface ChangeNoPwdJson {
    token: string,
    newpassword: string,
    repassword: string
}
export const changeNoPwd = (json: ChangeNoPwdJson): any => http.httpPost({
    url: httpApi.user.changeNoPwd,
    json
})

interface GetRegionData {
    token: string,
    id: string
}
export const getRegion = (json: GetRegionData): any => http.httpGet({
    url: httpApi.user.getRegion,
    json
})

// 获取当前用户登录信息
export const getByRefresh = (json: InfoJson): any => http.httpGet({
    url: httpApi.user.getByRefresh,
    json
})
// 获取推荐头像列表
export const getDefineImage = (json: InfoJson): any => http.httpGet({
    url: httpApi.user.getDefineImage,
    json
})

// 用户资料编辑
interface GetEditData {
    token: string,
    nick_name: string,
    sex: string,
    birthday_time: string,
    province: string,
    city: string,
    introduction: string
}
export const getEdit = (json: GetEditData): any => http.httpPost({
    url: httpApi.user.getEdit,
    json
})

// 盒子号更改
interface UpdateAccountJson {
    token: string,
    account: string
}
export const UpdateAccount = (json: UpdateAccountJson): any => http.httpPost({
    url: httpApi.user.updateAccount,
    json
})

// 用户主页--评价
interface GameRecordData {
    token: string,
    size: string,
    page: string
}
export const gameRecord = (json: GameRecordData): any => http.httpGet({
    url: httpApi.user.gameRecord,
    json
})

// 用户主页--评价
interface AppraiseData {
    token: string,
}
export const userPagePomment = (json: AppraiseData): any => http.httpGet({
    url: httpApi.user.user_page_comment,
    json
})

// 用户主页--通知
interface UserPageNoticeData {
    token: string,
}
export const userPageNotice = (json: UserPageNoticeData): any => http.httpGet({
    url: httpApi.user.user_page_notice,
    json
})

// 用户主页--回复
interface UserPageReplyData {
    token: string,
}
export const userPageReply = (json: UserPageReplyData): any => http.httpGet({
    url: httpApi.user.user_page_reply,
    json
})

// 用户主页--删除消息通知
interface DelNoticeData {
    message_id: string,
}
export const delNotice = (json: DelNoticeData): any => http.httpGet({
    url: httpApi.user.del_notice,
    json
})

// 用户主页--通知阅读更改
interface ReadData {
    message_id: string,
}
export const read = (json: ReadData): any => http.httpGet({
    url: httpApi.user.read,
    json
})

// 推荐用户头像上传
interface RecommendData {
    token: string,
    img_id: string
}
export const Recommend = (json: RecommendData): any => http.httpPost({
    url: httpApi.user.Recommend,
    json
})

// 用户图片上传
interface UploadImgData {
    token: string,
    file: string
}
export const UploadImg = (json: UploadImgData): any => http.httpPost({
    url: httpApi.UploadImage.UploadImg,
    json
})

// 用户消息--点赞
interface PraiseData {
    token: string
}

interface PraisePageData {
    token: string,
    page: number
}
export const Praise = (json: PraisePageData): any => http.httpGet({
    url: httpApi.Message.Praise,
    json
})

// 用户消息--回复
export const Reply = (json: PraisePageData): any => http.httpGet({
    url: httpApi.Message.Reply,
    json
})

// 用户消息--通知
export const Notice = (json: PraisePageData): any => http.httpGet({
    url: httpApi.Message.Notice,
    json
})

// 获取未读消息数量
export const MessageNum = (json: PraiseData): any => http.httpGet({
    url: httpApi.Message.MessageNum,
    json
})

// 用户消息通知阅读状态更改
interface ReadnoticeData {
    token: string,
    sender_id: string,
    system_id: string
}
export const Readnotice = (json: ReadnoticeData): any => http.httpGet({
    url: httpApi.Message.Readnotice,
    json
})

// 点赞阅读状态更改
interface ReadpraiseData {
    token: string,
    praise_id: string,
    uid: string
}

export const Readpraise = (json: ReadpraiseData): any => http.httpGet({
    url: httpApi.Message.Readpraise,
    json
})

// 回复消息阅读状态更改
interface ReadreplyData {
    token: string,
    reply_id: string,
    uid: string
}

export const Readreply = (json: ReadreplyData): any => http.httpGet({
    url: httpApi.Message.Readreply,
    json
})

// 删除系统消息
interface DeletenoticeData {
    token: string
}
export const Deletenotice = (json: DeletenoticeData): any => http.httpGet({
    url: httpApi.Message.Delnotice,
    json
})

// 获取其他用户信息
interface OtherUserInfoData {
    uid: string
}
export const otherUserInfo = (json: OtherUserInfoData): any => http.httpGet({
    url: httpApi.user.other_user_info,
    json
})

// 其他用户主页---评价
interface OtherUserCommentData {
    uid: string
}
export const otherUserComment = (json: OtherUserCommentData): any => http.httpGet({
    url: httpApi.user.other_user_comment,
    json
})

// 其他用户主页---回复
interface OtherUserReplyData {
    uid: string
}
export const otherUserReply = (json: OtherUserReplyData): any => http.httpGet({
    url: httpApi.user.other_user_reply,
    json
})

// 其他用户主页---下载记录
interface OtherUserDownloadRecordData {
    uid: string,
    is_time_show: string
}
export const otherUserDownloadRecord = (json: OtherUserDownloadRecordData): any => http.httpGet({
    url: httpApi.user.other_user_download_record,
    json
})
